import { render, staticRenderFns } from "./queryclose.vue?vue&type=template&id=6ab9ecf4&scoped=true&"
import script from "./queryclose.vue?vue&type=script&lang=js&"
export * from "./queryclose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9ecf4",
  null
  
)

export default component.exports